import { useSEO } from '../../hooks/useSEO';
import Header from '../../components/feature/Header';
import Hero from '../../components/feature/Hero';
import VideoSection from '../../components/feature/VideoSection';
import USP from '../../components/feature/USP';
import DashboardPreview from '../../components/feature/DashboardPreview';
import AhaEffects from '../../components/feature/AhaEffects';
import Categories from '../../components/feature/Categories';
import TelegramSection from '../../components/feature/TelegramSection';
import CTA from '../../components/feature/CTA';
import Testimonials from '../../components/feature/Testimonials';
import Partnership from '../../components/feature/Partnership';
import Privacy from '../../components/feature/Privacy';
import Footer from '../../components/feature/Footer';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://yourmindshift24.com';

export default function HomePage() {
  useSEO({
    title: 'YourMindShift24 – KI-Coach für Klarheit, Fokus & mentale Stärke | 7 Tage kostenlos',
    description: 'YourMindShift24: Dein persönlicher KI-Coach für tägliche Reflexion, Zielverfolgung und mentale Stärke. Muster-Erkennung, personalisierte Empfehlungen, Streak-Tracking – DSGVO-konform & verschlüsselt.',
    keywords: 'KI-Coach, Selbstreflexion, mentale Stärke, Zielverfolgung, YourMindShift24, Mindshift AI, KI Reflexion, Check-ins, persönliches Wachstum',
    canonical: '/',
    ogTitle: 'YourMindShift24 – Dein KI-Coach für mentale Stärke & Fokus',
    ogDescription: 'Tägliche KI-Reflexion, Zielverfolgung und personalisierte Empfehlungen. 7 Tage kostenlos testen.',
    ogImage: `${SITE_URL}/og-image.jpg`,
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: 'YourMindShift24',
        url: SITE_URL,
        description: 'KI-Coach für tägliche Reflexion, Zielverfolgung und mentale Stärke',
        potentialAction: {
          '@type': 'SearchAction',
          target: `${SITE_URL}/?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'Future Now UG',
        url: SITE_URL,
        logo: `${SITE_URL}/favicon.svg`,
        address: {
          '@type': 'PostalAddress',
          streetAddress: 'Max-Planck-Str. 4',
          addressLocality: 'Aschheim',
          postalCode: '85609',
          addressCountry: 'DE',
        },
        contactPoint: {
          '@type': 'ContactPoint',
          contactType: 'customer support',
          email: 'olaf.niggemann@icloud.com',
          availableLanguage: 'German',
        },
        sameAs: ['https://t.me/mindshift_ai_bot'],
      },
      {
        '@context': 'https://schema.org',
        '@type': 'SoftwareApplication',
        name: 'YourMindShift24',
        applicationCategory: 'HealthApplication',
        operatingSystem: 'Web, Telegram',
        description: 'KI-gestützter Coach für Klarheit, Fokus und mentale Stärke mit täglichen Check-ins, Zielverfolgung und personalisierten Empfehlungen.',
        offers: {
          '@type': 'Offer',
          price: '19',
          priceCurrency: 'EUR',
          description: '7 Tage kostenlos testen, danach 19€/Monat. Jederzeit kündbar.',
        },
        publisher: {
          '@type': 'Organization',
          name: 'Future Now UG',
          url: SITE_URL,
        },
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: '4.9',
          reviewCount: '127',
        },
      },
    ],
  });

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <VideoSection />
      <section id="features">
        <USP />
      </section>
      <DashboardPreview />
      <AhaEffects />
      <section id="bereiche">
        <Categories />
      </section>
      <section id="telegram">
        <TelegramSection />
      </section>
      <CTA />
      <section id="erfahrungen">
        <Testimonials />
      </section>
      <section id="partnership">
        <Partnership />
      </section>
      <Privacy />
      <Footer />
    </div>
  );
}
